import gql from "graphql-tag";

export default gql`
  mutation CreateAsset(
    $name: String!
    $description: String
    $category: String
    $barcode: String
    $model: String
    $siteId: ID
    $userId: ID
    $companyId: ID!
  ) {
    createAsset(
      name: $name
      description: $description
      category: $category
      barcode: $barcode
      model: $model
      siteId: $siteId
      primaryUserId: $userId
      companyId: $companyId
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/CreateAsset.ts